<template>
  <div @click="selectPrefecture()">
    <small class="label">{{ $l.userPrefecture }}</small>
    <input
      type="text"
      class="input-text with-label"
      v-model="prefecture"
      :placeholder="$l.userPrefecture"
      disabled
      >
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],


  computed: {
    prefecture: function () {
      const prefecture = this.$store.state.user.prefecture
      if (prefecture) {
        return prefecture.get(this.locale)
      }
      return ''
    }
  },

  methods: {
    selectPrefecture: function () {
      this.$store.dispatch('popup/show', 'user-prefecture')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
